<template>
  <svg width="170" height="144" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity=".5"
      d="M86.766 143.196c45.693 0 82.734-5.137 82.734-11.474 0-6.337-37.041-11.474-82.734-11.474-45.692 0-82.733 5.137-82.733 11.474 0 6.337 37.04 11.474 82.733 11.474Z"
      fill="#F5F5F5"
    />
    <path
      d="M71.88 111.121a29.83 29.83 0 0 0-.311-4.729c-.237-1.615-.994-6.775-3.715-10.674-4.112-5.894-8.773-3.266-13.552-9.359-2.734-3.487-1.965-5.314-5.093-8.106-2.762-2.465-5.728-3.373-8.888-3.893-7.996-1.315-21.041-.081-21.041-.081 1.101 12.644 5.352 17.872 9.02 20.311 5.147 3.424 9.107 1.326 13.695 5.424 5.972 5.335 2.052 11.379 7.622 16.929 0 0 2.438 2.43 21.362 6.027l.901-11.849Z"
      fill="#F5F5F5"
    />
    <path
      d="M70.98 122.97S56.36 98.089 50.79 93.213C45.223 88.337 19.28 74.279 19.28 74.279M38.053 84.89l-16.33.913M41.426 86.91 42.51 74.8M48.852 91.708 34.718 96.93M54.831 97.915l1.819-9.182M59.392 104.42 45.7 106.921M62.964 109.904l5.152-13.797M66.214 115.089l-15.837 2.334"
      stroke="#D6D6D6"
      stroke-width=".466"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M63.188 113.069a29.762 29.762 0 0 0-2.096-4.25c-.836-1.403-3.507-5.881-7.512-8.445-6.052-3.874-9.355.336-16.1-3.468-3.86-2.177-3.847-4.16-7.804-5.544-3.495-1.223-6.583-.928-9.701-.2C12.083 93.001.5 99.127.5 99.127c5.85 11.263 11.776 14.47 16.098 15.322 6.065 1.196 8.923-2.255 14.729-.222 7.558 2.647 6.245 9.731 13.513 12.731 0 0 3.182 1.313 22.044-2.596l-3.696-11.294Z"
      fill="#F5F5F5"
    />
    <path
      d="M66.884 124.363s-23.019-17.405-30.028-19.782C29.846 102.203.5 99.128.5 99.128M21.903 101.758l-14.74 7.086M25.793 102.336l-3.627-11.605M34.488 103.932 23.423 114.16M42.386 107.382l-1.83-9.18M49.087 111.65l-11.697 7.544M54.483 115.353l-.512-14.719M59.468 118.901l-13.742 8.211"
      stroke="#D6D6D6"
      stroke-width=".466"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M116.45 124.552H66.606l4.8-32.96h40.244l4.8 32.96Z"
      fill="#8578B2"
    />
    <path
      d="M153.502 97.403H29.555a5.702 5.702 0 0 1-5.702-5.702V13.616a5.702 5.702 0 0 1 5.702-5.702h123.947a5.702 5.702 0 0 1 5.702 5.702v78.085a5.702 5.702 0 0 1-5.702 5.702Z"
      fill="#B1A8D3"
    />
    <path
      d="M150.218 88.014H32.839a5.702 5.702 0 0 1-5.702-5.702V16.31a5.702 5.702 0 0 1 5.702-5.702h117.379a5.702 5.702 0 0 1 5.702 5.702v66.002a5.702 5.702 0 0 1-5.702 5.702Z"
      fill="#D7D3E8"
    />
    <path
      d="M127.015 126.952H56.041v-3.429a4.8 4.8 0 0 1 4.8-4.8h61.374a4.8 4.8 0 0 1 4.8 4.8v3.429Z"
      fill="#7A6DA7"
    />
    <path
      d="M31.336 88.014H149.34M59.166 125.238v-1.8c0-1.089.882-1.972 1.971-1.972h53.231M108.71 100.037l1.886 14.401"
      stroke="#262626"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M90.338 95.761a2.761 2.761 0 1 0 0-5.523 2.761 2.761 0 0 0 0 5.523Z"
      fill="#fff"
    />
    <path
      d="M129.625 15.862h14.658a5.057 5.057 0 0 1 5.057 5.058v30.456"
      stroke="#fff"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M140.811 25.51c.847-2.037 1.684-3.612 2.511-4.726.828-1.113 1.905-2.002 3.234-2.664a9.333 9.333 0 0 1 2.428-.873c.842-.176 1.643-.4 2.404-.671a8.284 8.284 0 0 0 2.098-1.102c.638-.463 1.165-1.196 1.581-2.197.703-1.691.729-3.068.077-4.128-.653-1.061-1.618-1.857-2.895-2.388-1.83-.76-3.302-.775-4.415-.044-1.115.732-2.117 1.925-3.007 3.58l-6.68-2.778c.703-1.69 1.618-3.113 2.744-4.264 1.126-1.151 2.4-1.999 3.82-2.542 1.42-.543 2.954-.776 4.603-.698 1.647.077 3.334.475 5.061 1.192 3.729 1.55 6.355 3.533 7.883 5.95 1.525 2.416 1.579 5.332.158 8.75-.46 1.106-.974 2.025-1.542 2.76a8.307 8.307 0 0 1-1.947 1.833c-.729.487-1.543.887-2.443 1.202-.9.314-1.893.61-2.98.887-1.004.271-1.842.56-2.516.867a6.12 6.12 0 0 0-1.719 1.138 6.52 6.52 0 0 0-1.187 1.54 19.443 19.443 0 0 0-.953 2.003l-6.318-2.627Zm-4.362 9.909 2.82-6.784 6.991 2.906-2.82 6.784-6.991-2.906Z"
      fill="#3897E9"
    />
    <path
      d="M100.075 35.691v-5.54a3.29 3.29 0 0 0-3.29-3.29h-32.16a3.29 3.29 0 0 0-3.29 3.29V72.6a3.29 3.29 0 0 0 3.29 3.29h51.426a3.29 3.29 0 0 0 3.29-3.29V38.982a3.29 3.29 0 0 0-3.29-3.29h-15.976Z"
      fill="#F5F5F5"
    />
    <path
      d="m96.817 43.43-6.48 6.479-6.478-6.48-3.91 3.91 6.479 6.48-6.479 6.479 3.91 3.909 6.479-6.479 6.479 6.479 3.91-3.91-6.48-6.478 6.48-6.48-3.91-3.91Z"
      fill="#D6D6D6"
    />
    <path
      d="M20.137 126.632v-4.265h-7.855v11.73l17.737.284v-2.132l-9.881-5.617Z"
      fill="#F7A99C"
    />
    <path
      d="M30.647 134.381v-1.011a2.812 2.812 0 0 0-1.477-2.475l-7.48-4.038c-2.243.613-3.976.527-5.16.326-1.967-.333-3.846-1.227-4.479-.48-.18.214-.203.495-.195.688v6.202c0 .436.353.788.788.788h18.003Z"
      fill="#FFC001"
    />
    <path
      d="M30.647 133.706H11.855M26.507 129.542l-1.053 1.392M25.735 129.107l-1.052 1.391M24.93 128.703l-1.053 1.391M23.743 127.966a16.69 16.69 0 0 1-11.887 0"
      stroke="#3897E9"
      stroke-width=".733"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42.532 126.632v-4.265h-7.856v11.73l17.737.284v-2.132l-9.881-5.617Z"
      fill="#F7A99C"
    />
    <path
      d="M53.041 134.381v-1.011a2.812 2.812 0 0 0-1.477-2.475l-7.48-4.038c-2.243.613-3.976.527-5.16.326-1.967-.333-3.847-1.227-4.48-.48-.18.214-.202.495-.195.688v6.202c0 .436.353.788.788.788h18.004Z"
      fill="#FFC001"
    />
    <path
      d="M53.041 133.706H34.249M48.9 129.542l-1.052 1.392M48.13 129.107l-1.053 1.391M47.324 128.703l-1.053 1.391M46.137 127.966a16.69 16.69 0 0 1-11.888 0"
      stroke="#3897E9"
      stroke-width=".733"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.017 65.884s6.47 20.546 7.465 23.39c.995 2.843 1.92 6.825 1.706 10.308-.214 3.483-3.555 24.953-3.555 24.953h-9.74s-.687-22.679-1.019-24.456c-.331-1.777-3.175-11.83-3.175-11.83s-.924 11.759-1.706 14.887c-.782 3.128-7.038 21.754-7.038 21.754h-9.1l3.84-59.006h22.322Z"
      fill="#3897E9"
    />
    <path
      d="M52.865 53.36s3.089-2.62 3.87-4.335c.67-1.467 1.605-4.045 1.86-4.758a.223.223 0 0 1 .263-.14l.185.043c.573.136.927.712.79 1.284l-.309 1.285 3.264-2.143a.58.58 0 0 1 .661.954l-2.153 1.57 3.577-1.679a.586.586 0 0 1 .758.24l.005.008c.16.282.062.64-.22.8l.04-.011a.655.655 0 0 1 .427 1.235l-.227.092a.523.523 0 0 1 .669.398 1.02 1.02 0 0 1-.529 1.104c-.962.501-1.587.633-2.502 1.318-.724.542-.47.887-1.243 1.875-.94 1.203-1.741 1.237-3.361 2.428a14.066 14.066 0 0 0-2.363 2.207l-3.462-3.775Z"
      fill="#F7A99C"
    />
    <path
      d="M63.663 44.923s.165.332-.147.57c-.312.236-2.744 2.037-2.744 2.037M65.417 46.49l-3.349 1.554M65.761 47.785l-3.366 1.55M59.277 44.257s.588.372.572.785c-.016.413-.61 3.064-.61 3.064"
      stroke="#262626"
      stroke-width=".415"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.894 124.535s-.881-23.253-.95-23.854c-.069-.601-3.383-12.909-3.383-12.909l.587-5.44s6.686 16.458 6.686 17.544c0 1.086.742 24.659.742 24.659h-3.682Z"
      fill="#1775AF"
    />
    <path
      d="m28.373 101.713 2.376-25.698"
      stroke="#262626"
      stroke-width=".415"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M44.008 122.562h-10.19l.076 1.973h9.74l.374-1.973ZM21.546 123.128H11.97l-.115 1.763h9.1l.59-1.763Z"
      fill="#262626"
    />
    <path
      d="M44.6 91.305a24.59 24.59 0 0 1 .587 12.617"
      stroke="#fff"
      stroke-width=".415"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M55.433 50.596s-1.65 1.27-3.528 1.6c-2.202.387-4.11-.917-4.623-1.267-1.396-.953-1.912-2.083-2.835-3.404-2.734-3.914-4.432-6.345-6.81-7.722-1.228-.712-3.283-1.515-6.523-1.267-.727-.26-1.885-.054-2.661-.054h-1.935c-1.272.153-10.639 1.24-12.231-.222-.628-.576-.638-1.144-.638-1.144-.008-.47.288-.958 1.064-1.549 1.897-1.444 5.376-2.522 6.54-2.866l-.71-5.31h-1.564c-1.564 0-7.11.925-10.095 1.968-4.187 1.463-6.43 2.53-7.536 4.955-1.386 3.04.09 6.305.474 7.154 1.922 4.251 6.184 5.972 8.759 7.011a22.027 22.027 0 0 0 5.696 1.449L15.07 69.265l22.226 1.208h3.337c.256-2.954-1.022-12.135-.857-15.133 2.838 3.949 7.538 5.943 12 5.085 4.94-.949 7.425-4.977 7.83-5.657-1.724-3.401-4.172-4.172-4.172-4.172Z"
      fill="#4450E4"
    />
    <path
      d="M27.818 49.196h-.214v-9.23h1.4v8.044c0 .655-.53 1.186-1.186 1.186Z"
      fill="#fff"
    />
    <path
      d="M40.666 69.454c-.765.142-11.286 1.906-18.72-5.943-6.272-6.623-5.53-15.005-5.4-16.245l-1.171 17.441h-.021l-.285 4.557 3.484.19-.002-.025a348.622 348.622 0 0 0 22.082 1.044l.033-1.02Z"
      fill="#3748C4"
    />
    <path
      d="M34.773 31.496c.38-1.955.321-3.483.21-4.46-.083-.743-.213-1.306-.608-1.84-.083-.114-.739-.976-1.864-1.2-1.346-.27-1.685.707-3.6.944-1.65.204-1.976-.451-3.086.02-1.213.514-1.811 1.714-1.993 2.078-.08.16-.474.974-.514 2.115-.032.903.174 1.583.256 1.861.344 1.17.749 2.95 1.244 5.797l.775-.03 9.18-5.285Z"
      fill="#262626"
    />
    <path
      d="M28.227 41.111a2.617 2.617 0 0 1-2.627-2.607l-.021-5.634 5.235-.02.022 5.634a2.618 2.618 0 0 1-2.608 2.627Z"
      fill="#F7A99C"
    />
    <path
      d="m30.83 36.907-3.41-1.752c.034.295.228 1.678 1.444 2.633.777.61 1.593.75 1.97.789l-.005-1.67Z"
      fill="#FF7769"
    />
    <path
      d="M25.452 31.125c-.017-.085-.241-.214-.31-.258a1.604 1.604 0 0 0-.374-.176 1.521 1.521 0 0 0-.798-.04c-.522.119-.985.557-1.072 1.094-.05.312.022.635.155.921.201.431.542.793.954 1.03.341.197.73.308 1.122.331.079.005.884-.014.878-.045-.186-.952-.37-1.905-.555-2.857Z"
      fill="#F7A99C"
    />
    <path
      d="M24.734 31.18c.062.42.431 2.637 2.43 4.203.368.289 2.815 2.207 5.054 1.27 2.877-1.202 2.563-5.928 2.543-6.184-.068-.866-.27-3.414-2.38-4.774-1.723-1.11-3.59-.701-3.854-.639-.279.066-2.056.514-3.143 2.256-.988 1.581-.752 3.18-.65 3.867Z"
      fill="#F7A99C"
    />
    <path
      d="M33.128 30.472c.046.37.33.637.636.599.304-.038.514-.368.467-.737-.046-.37-.33-.637-.635-.6-.305.04-.514.37-.468.738ZM29.803 30.89c.046.369.33.637.636.598.304-.038.514-.368.467-.737-.046-.369-.33-.637-.635-.599-.305.038-.514.369-.468.738Z"
      fill="#262626"
    />
    <path
      d="m32.124 31.024.51.689a.268.268 0 0 1-.076.388l-.468.285"
      stroke="#262626"
      stroke-width=".733"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.688 32.628a.755.755 0 1 0 1.499-.189.755.755 0 0 0-1.499.189Z"
      fill="#FF7769"
    />
    <path
      d="M25.1 33.018c.003-.083.01-.645-.441-1.05a1.364 1.364 0 0 0-.877-.341"
      stroke="#262626"
      stroke-width=".733"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.702 32.078c-.025-.004-.327-.046-.538.183a.615.615 0 0 0-.155.46"
      stroke="#262626"
      stroke-width=".733"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.668 30.663s.372.033.652.311c.28.279.38.755.38.755.716-.087 2.358-.39 3.847-1.681.807-.701 1.3-1.458 1.59-2.005a5.1 5.1 0 0 0 1.39.894c.855.368 1.923.545 2.064.258.026-.053-.002-.207-.06-.515-.021-.111-.044-.276-.098-.434a4.986 4.986 0 0 0-.407-.889 5.167 5.167 0 0 0-1.282-1.468 4.91 4.91 0 0 0-1.093-.646c-1.242-.528-2.965-.528-4.448.263 0 0-1.656.883-2.386 2.612a4.683 4.683 0 0 0-.33 1.394c-.031.408.015.674.077.879.035.116.074.209.104.272Z"
      fill="#262626"
    />
    <path
      d="M34.369 31.433a.748.748 0 0 1 .404.063c-.015.406-.054.898-.143 1.42-.024.005-.047.013-.073.016a.756.756 0 0 1-.188-1.5Z"
      fill="#FF7769"
    />
    <path
      d="M28.825 25.152a12.169 12.169 0 0 0-1.05-.353c-.973-.28-1.459-.419-1.901-.362-1.296.166-2.04 1.874-2.352 2.59-.237.542-.623 1.462-.418 2.615.09.513.271.914.415 1.179M28.825 24.998c.438-.191.907-.346 1.329-.566.443-.23.83-.53 1.304-.706.498-.186 1.055-.26 1.563-.106.439.133.814.426 1.123.764.417.455.735 1.005.9 1.6.318 1.146.034 2.34-.154 3.483"
      stroke="#262626"
      stroke-width=".25"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.686 33.963c0 .372-.362.674-.81.674-.447 0-.81-.302-.81-.674 0-.373.363-.674.81-.674.448 0 .81.302.81.674Z"
      fill="#fff"
    />
    <path
      d="m20.665 28.302 1.496-.91s.305-1.318.72-1.597c.416-.278 2.623-1.136 2.623-1.136l.321.3s-1.727 1.578-2.084 2.279c-.359.7-.426 2.65-.426 2.65l-1.69 2.185-.413.313-.547-4.084Z"
      fill="#F7A99C"
    />
    <path
      d="M16.546 48.106 15.76 58.21M39.39 48.932l.603 11.15"
      stroke="#262626"
      stroke-width=".415"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.86 33.018c-.312.248-1.929 1.586-2.19 3.948-.285 2.573 1.262 4.335 1.504 4.6M43.261 56.082c.416.462 2.033 2.146 4.749 2.514 2.576.348 4.498-.71 5.052-1.043"
      stroke="#fff"
      stroke-width=".415"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m113.886 64.935 3.467-1.853 5.143.943 2.571-2.744 6.086 1.63 3.386-4.63 6.047 3.707-2.058-13.07-7.978-5.586-18.336 2.886a1.258 1.258 0 0 0-1.048 1.438l2.72 17.28Z"
      fill="#F5F5F5"
    />
    <path
      d="m132.414 49.88 6.114-.962-7.978-5.586.923 5.863a.823.823 0 0 0 .941.685Z"
      fill="#D6D6D6"
    />
    <path
      d="m130.55 43.331.923 5.864a.823.823 0 0 0 .941.685l6.115-.963"
      stroke="#262626"
      stroke-width=".274"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M116.357 82.096a1.259 1.259 0 0 0 1.439 1.048l24.021-3.78a1.257 1.257 0 0 0 1.047-1.44l-2.278-14.48-6.047-3.705-3.386 4.628-6.085-1.628-2.572 2.743-5.143-.943-3.467 1.853 2.471 15.704Z"
      fill="#F5F5F5"
    />
    <path
      d="m113.891 64.935 3.467-1.853 5.143.943 2.571-2.744 6.086 1.63 3.386-4.63 6.046 3.707-2.057-13.07-7.978-5.586-18.337 2.886a1.258 1.258 0 0 0-1.047 1.438l2.72 17.28Z"
      stroke="#262626"
      stroke-width=".274"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M116.362 82.096a1.258 1.258 0 0 0 1.439 1.048l24.021-3.78a1.258 1.258 0 0 0 1.047-1.44l-2.279-14.48-6.046-3.705-3.386 4.628-6.086-1.628-2.571 2.743-5.143-.943-3.468 1.853 2.472 15.704Z"
      stroke="#262626"
      stroke-width=".274"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m20.962 24.283-.607.578-5.363-4.842 1.544-1.473 4.426 5.737ZM22.287 23.29l-.825.152-1.84-6.988 2.099-.387.566 7.223ZM19.428 25.6l-.068.836-7.227-.054.176-2.127 7.12 1.346Z"
      fill="#FF7129"
    />
    <path
      d="M105.763 131.556a4.602 4.602 0 0 1-.057-6.509l21.193-21.565 6.566 6.453-21.193 21.564a4.603 4.603 0 0 1-6.509.057Z"
      fill="#D1C200"
    />
    <path
      opacity=".2"
      d="M143.578 111.734c10.279-.023 18.593-8.376 18.569-18.655-.023-10.28-8.375-18.594-18.655-18.57-10.279.024-18.593 8.376-18.57 18.655.024 10.28 8.376 18.594 18.656 18.57Z"
      fill="#DCF0FF"
    />
    <path
      opacity=".5"
      d="M126.112 99.686a18.484 18.484 0 0 0 2.626 4.734l33.401-11.553a18.664 18.664 0 0 0-.859-5.345l-35.168 12.164ZM124.962 94.356a18.58 18.58 0 0 0 .478 3.14l35.017-12.111a18.424 18.424 0 0 0-1.563-2.765l-33.932 11.736Z"
      fill="#fff"
    />
    <path
      d="M158.587 77.806c-8.461-8.316-22.061-8.198-30.377.264-8.316 8.46-8.198 22.061.264 30.377 8.461 8.316 22.061 8.197 30.377-.264 8.316-8.462 8.198-22.062-.264-30.377Zm-27.456 27.937c-6.968-6.848-7.065-18.048-.217-25.016 6.848-6.969 18.048-7.066 25.016-.218s7.065 18.049.217 25.017c-6.848 6.968-18.048 7.065-25.016.217Z"
      fill="#D1C200"
    />
    <path
      d="m128.387 111.919-16.758 17.051M145.071 73.19c-5.28-.534-10.754 1.289-14.661 4.88s-6.184 8.892-6.097 14.198"
      stroke="#fff"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
